<div class="legend-container" *ngIf="!!dataSource.length && data?.showLegend">
  <div class="legend-item" (click)="filterByLegend('impact drivers')"
    [class.active]="activeLegend?.toLowerCase() === 'impact drivers'">
    <div class="legend-color-box" style="background-color: var(--dvm-table-common-bg, #DCEAF7);"></div>
    <span>Impact drivers</span>
  </div>
  <div class="legend-item" (click)="filterByLegend('non-impact drivers')"
    [class.active]="activeLegend?.toLowerCase() === 'non-impact drivers'">
    <div class="legend-color-box" style="background-color: var(--dvm-table-non-common-bg, #f2f2f2);"></div>
    <span>Non Impact drivers</span>
  </div>
</div>
<div class="card table-wrapper"
  [style.height]="tableHeight"
  [style.--dvm-table-frozen-bg]="data?.freezeColumnBg || data?.freezeColumnColor || null"
  [style.--dvm-table-first-frozen-bg]="data?.freezeFirstColumnBg || data?.freezeColumnBg || data?.freezeColumnColor || null"
  [style.--dvm-table-first-frozen-text]="data?.freezeFirstColumnTextColor || data?.freezeColumnTextColor || null">
  <div class="table-spinner-overlay" *ngIf="isLoading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <div class="table-scroll-container" *ngIf="!!dataSource.length">
    <div class="table-content-wrapper">
      <!-- Grouped header row (year headers) - uses real table for pixel-perfect alignment -->
      <table class="grouped-header-table" *ngIf="hasGroupedHeaders"
        [class.has-collapsed-cols]="collapsedColumns.size > 0">
        <colgroup>
          <col *ngFor="let col of displayedColumns" [style.width.px]="columnWidths[col]" [style.max-width.px]="columnWidths[col]">
        </colgroup>
        <thead>
          <tr *ngFor="let headerRow of headerGroupRows; let rowIndex = index">
            <th *ngFor="let group of headerRow" class="grouped-header-cell"
              [attr.colspan]="group.colspan"
              [attr.rowspan]="group.rowspan"
              [class.selected-header]="isGroupHeaderSelected(group.groupId)"
              [class.single-quarter-year-header]="isSingleQuarterYearGroup(getHeaderGroupNode(group.groupId))"
              [class.clickable-header]="!!group.label"
              [class.quarterly-static-group]="isQuarterlyIdentifierGroup(getHeaderGroupNode(group.groupId))"
              [class.frozen-col]="group.frozen"
              [class.first-frozen-col]="isFirstFrozenGroup(getHeaderGroupNode(group.groupId))"
              [class.collapsed-group]="isGroupCollapsed(group)"
              [style.left.px]="getFrozenGroupLeft(getHeaderGroupNode(group.groupId))"
              (click)="onGroupHeaderClick(group, $event)">
              <span class="group-label-text">{{ formatHeaderLabel(group.label) }}</span>
              <span *ngIf="!!group.label && group.columns.length > 0" class="collapse-group-toggle"
                (click)="toggleGroupCollapse(group, $event)"
                [title]="isGroupCollapsed(group) ? 'Expand ' + group.label : 'Collapse ' + group.label">
                {{ isGroupCollapsed(group) ? '&#9654;' : '&#9664;' }}
              </span>
            </th>
          </tr>
        </thead>
      </table>

      <table mat-table [dataSource]="data?.isPagination ? pagedData : dataSource" class="custom-table resizable-table"
        [class.has-collapsed-cols]="collapsedColumns.size > 0">
        <colgroup>
          <col *ngFor="let col of displayedColumns" [style.width.px]="columnWidths[col]" [style.max-width.px]="columnWidths[col]">
        </colgroup>
        <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
          <th class="tableheader" mat-header-cell *matHeaderCellDef
            [class.clickable-header]="!isQuarterlyIdentifierColumn(column) && !isColumnCollapsed(column)"
            [class.selected-header]="isColumnHeaderSelected(column)"
            [class.frozen-col]="isFrozenColumn(column)"
            [class.first-frozen-col]="isFirstFrozenColumn(column)"
            [class.frozen-col-last]="isLastFrozenColumn(column)"
            [class.no-freeze-row]="data?.freezeRow === false"
            [class.collapsed-col-header]="isColumnCollapsed(column)"
            [class.column-divider]="showDivider(column)"
            [style.width.px]="columnWidths[column]"
            [style.min-width.px]="columnWidths[column]"
            [style.max-width.px]="columnWidths[column]"
            [style.left.px]="getFrozenColumnLeft(column)"
            (mousedown)="isColumnCollapsed(column) ? null : onHeaderMouseDown($event, column)"
            (click)="isColumnCollapsed(column) ? toggleColumnCollapse(column, $event) : (isQuarterlyIdentifierColumn(column) ? null : onColumnHeaderClick(column, $event))">
            <div class="header-content" *ngIf="!isColumnCollapsed(column)">
              <span class="header-label">{{ columnLabels[column] }}</span>
              <span class="collapse-col-toggle"
                (mousedown)="$event.stopPropagation()"
                (click)="toggleColumnCollapse(column, $event)"
                title="Collapse column">&#9664;</span>
            </div>
            <span class="collapsed-col-label" *ngIf="isColumnCollapsed(column)"
              [title]="'Expand ' + columnLabels[column]">{{ columnLabels[column] }}</span>
            <!-- Resize handle -->
            <div class="resize-handle" *ngIf="!isColumnCollapsed(column)"
              (mousedown)="onResizeStart($event, column)" (click)="$event.stopPropagation()">
            </div>
          </th>
          <td class="tablebody" mat-cell *matCellDef="let row" (click)="onCellClick(row, column, $event)"
            [class.frozen-col]="isFrozenColumn(column)"
            [class.first-frozen-col]="isFirstFrozenColumn(column)"
            [class.frozen-col-last]="isLastFrozenColumn(column)"
            [class.collapsed-col-cell]="isColumnCollapsed(column)"
            [class.column-divider]="showDivider(column)"
            [style.width.px]="columnWidths[column]" [style.min-width.px]="columnWidths[column]" [style.max-width.px]="columnWidths[column]"
            [style.left.px]="getFrozenColumnLeft(column)"
            [class.selected-cell]="isCellSelected(row, column)"
            [class.highlighted-column]="isColumnHighlighted(column)">
            <span *ngIf="!isColumnCollapsed(column)">{{ row[column] }}</span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index"
          [style.--frozen-row-top.px]="getFrozenBodyRowTop(i)"
          [style.--frozen-row-bottom.px]="getFrozenBodyRowBottom(i)"
          [ngClass]="{
            'frozen-body-row': isFrozenBodyRow(i),
            'common-background': row.option_impact_drivers?.toLowerCase() === 'impact drivers',
            'non-common-background': row.option_impact_drivers?.toLowerCase() === 'non-impact drivers',
            'even-row': i % 2 === 0,
            'odd-row': i % 2 !== 0
          }">
        </tr>

      </table>
    </div>
  </div>
  @if (!!data?.isPagination && !!dataSource.length ) {
  <app-paginator (pageChange)="onPageChange($event)" #paginatorComp></app-paginator>
  }
</div>
